import { NodeEnum, type NodeDefault } from '../../types';
import type { Node } from '../../types';
import { LargeModelExtractionNodeType } from './types';

const nodeDefault: NodeDefault<Node<LargeModelExtractionNodeType>> = {
  author: 'PIKA',
  about: '大模型抽取节点',
  icon: 'icon-ai',
  color: '#2196F3',
  defaultData: {
    type: NodeEnum.LargeModelExtraction,
    modelConfig: '',
    name: '大模型抽取节点',
    title: '大模型抽取节点',
    desc: '大模型抽取节点',
  },

  name: '大模型抽取节点',
  getAvailablePrevNodes() {
    return [];
  },
  getAvailableNextNodes() {
    return [];
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;
